// Clinic contact information. Phone is the only direct contact channel.
// Practice is affiliated with Queensway Carleton Hospital, Ottawa, ON.

export const CLINIC_PHONE = "(613) 728-1795";
export const CLINIC_FAX = "(613) 728-0091";
export const CLINIC_HOURS = "Mon–Fri, 8:00 AM – 5:00 PM (ET)";
export const CLINIC_LOCATION_NAME = "Queensway Carleton Hospital";
export const CLINIC_ADDRESS = "3045 Baseline Road, Ottawa, ON  K2H 8P4";
export const CLINIC_MAP_URL =
    "https://www.google.com/maps/search/?api=1&query=Queensway+Carleton+Hospital+3045+Baseline+Road+Ottawa";
export const CLINIC_MAP_EMBED =
    "https://www.google.com/maps?q=Queensway+Carleton+Hospital,+3045+Baseline+Rd,+Ottawa,+ON&output=embed";
